import { TeContainer, TeContainerSlim } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import { PlaceholderContainer } from '@topcon/topcon-utils';

import { Section } from '../../utils/styling';
import CompanyTree from '../../components/Company/CompanyTree';
import ViewContainer from '../../components/ViewContainer';
import { useInvitesToJoin } from './companies.queries';
import {
  BusinessPartnerWithCurrentIdentityInfoBody,
  InviteToJoinBody,
} from '../../api/generated/pap';

function Invites() {
  const { t } = useTranslation('companies', { keyPrefix: 'inviteSection' });

  const { data: invitesToJoin, isLoading, refetch } = useInvitesToJoin();

  const companies = invitesToJoin
    ?.sort((a, b) =>
      // TODO: Fix all localeCompare's to respect user locale selection
      (a.businessPartner?.name ?? '').localeCompare(b.businessPartner?.name ?? '', 'fi', {
        numeric: true,
      })
    )
    .map(
      (
        inviteToJoin: InviteToJoinBody
      ): Partial<BusinessPartnerWithCurrentIdentityInfoBody> & { inviteId: string } => {
        return {
          id: inviteToJoin.businessPartner?.id ?? inviteToJoin.businessPartnerId,
          inviteId: inviteToJoin.id,
          name: inviteToJoin.businessPartner?.name ?? '',
          iconURL: inviteToJoin.businessPartner?.iconURL,
          parentBusinessPartnerId:
            inviteToJoin.businessPartner?.parentBusinessPartnerId ?? undefined,
        };
      }
    );
  const invitesCount = invitesToJoin?.length;
  const noContent = isLoading || !invitesToJoin?.length;

  const renderLoader = () => {
    return <PlaceholderContainer hasLoader text={t('loadingInvites')} />;
  };

  const renderNoInvites = () => {
    return <PlaceholderContainer grow icon="person_add" text={t('noInvites')} />;
  };

  const renderNoContent = () => {
    return (
      <TeContainerSlim
        backgroundColor="background.secondary"
        borderRadius={4}
        column
        fill
        justifyContent="center"
        alignItems="center"
      >
        {isLoading ? renderLoader() : renderNoInvites()}
      </TeContainerSlim>
    );
  };

  return (
    <TeContainerSlim column grow padding="xs" overflow="hidden" alignItems="center">
      <Section>
        <ViewContainer title={t('title')} visibleItemsCount={invitesCount} noPadding noSeparator>
          <TeContainer
            backgroundColor="background.primary"
            borderRadius={4}
            overflow="hidden"
            fill
            column
          >
            {noContent ? (
              renderNoContent()
            ) : (
              <CompanyTree type="inviteToJoin" companies={companies || []} onUpdate={refetch} />
            )}
          </TeContainer>
        </ViewContainer>
      </Section>
    </TeContainerSlim>
  );
}

export default Invites;
